import { motion, useTransform, useScroll } from "framer-motion";
import React, { useRef } from "react";
import { HiArrowRight } from "react-icons/hi2";
import { BsArrow90DegRight } from "react-icons/bs";

const HorizontalScrollCarousel = () => {
    const targetRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: targetRef,
    });

    const x = useTransform(scrollYProgress, [0, 1], ["1.5%", "-95%"]);

    return (
        <section ref={targetRef} className="relative h-[300vh]">
            <div className="sticky top-0 flex h-screen items-center overflow-hidden">
                <motion.div style={{ x }} className="flex gap-4">
                    {cards.map((card) => {
                        return <Card card={card} key={card.id} />;
                    })}
                </motion.div>
            </div>
        </section>
    );
};

const Card = ({ card }) => {
    return (
        <div
            key={card.id}
            className="group relative h-screen overflow-hidden flex items-center"
        >
            <div className="px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto flex">
                <div className={"w-[60rem] relative rounded-xl h-[75vh] overflow-hidden"}>
                    <img src={card.imgURL} className="w-full " alt="Knowledge"/>
                    <div className="absolute bottom-0 start-0 end-0 w-[25rem] mx-auto p-6 md:start-auto text-start md:mx-0">
                        <motion.div
                            className="backdrop-blur-sm bg-white/60 px-5 py-4 inline-block rounded-lg md:p-7"
                            variants={{
                                hidden: { opacity: 0, x: -50 },
                                visible: { opacity: 1, x: 0 }
                            }}
                            initial="hidden"
                            whileInView="visible"
                            transition={{duration: 0.6, delay: 0.4}}
                            viewport={{once: false}}
                        >
                            <div className="text-gray-800 text-lg">
                                <h3 className="text-xl font-bold text-blue-600 sm:text-2xl">{ card.situation }</h3>
                                <p className="mt-2 mb-2">{ card.p1 }</p>
                                <ul className="marker:text-blue-500 list-disc pl-5 mb-2">
                                    <li>{ card.li1 }</li>
                                    <li>{ card.li2 }</li>
                                    <li>{ card.li3 }</li>
                                </ul>
                                <p className="text-gray-800">{ card.p2 }</p>
                            </div>
                        </motion.div>
                    </div>
                </div>
                { card.id!==6 ?
                    <motion.div
                        className="text-6xl my-auto ml-24 mr-8"
                        variants={{
                            hidden: { opacity: 0, x: -50 },
                            visible: { opacity: 1, x: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.8}}
                        viewport={{once: false}}
                    >
                        <HiArrowRight />
                    </motion.div> :
                    <motion.div
                        className="my-auto text-6xl ml-24"
                        variants={{
                            hidden: { opacity: 0, y: -50 },
                            visible: { opacity: 1, y: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.8}}
                        viewport={{once: false}}
                    >
                        <BsArrow90DegRight className="rotate-90" />
                    </motion.div> }
            </div>
        </div>
    );
};

const cards = [
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/background-1.jpg",
        situation: "Huge market of cosmetics",
        p1: "Countless families are using cosmetic products as daily self-care routines, including…",
        li1: "Eyeshadows",
        li2: "Shampoos",
        li3: "Lipsticks",
        p2: "However, the manufacturing of cosmetic products causes →",
        id: 1
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/background-2.jpg",
        situation: "Environmental challenge",
        p1: "The unwanted emissions and disposals from the cosmetic industry are harming our planet…",
        li1: "Greenhouse gasses",
        li2: "Habitat damage",
        li3: "Resource overuse",
        p2: "One widely used cosmetic compartment is →",
        id: 2
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/background-3.jpg",
        situation: "Guanine crystal in cosmetics",
        p1: "Guanine, one of the bases of nucleotides, is used in multiple categories of cosmetics for physical properties of…",
        li1: "Shimmering",
        li2: "Rainbow effects",
        li3: "Opacity",
        p2: "A major natural source of guanine extraction is →",
        id: 3
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/background-4.jpg",
        situation: "Guanine from fish scale",
        p1: "The scales of fish contain high concentrations of guanine crystal for the cosmetic industry, which raises serious problems…",
        li1: "Brutal animal killing",
        li2: "Non-vegan choices",
        li3: "Ecosystem damages",
        p2: "A seemingly useful alternative is →",
        id: 4
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/background-5.jpg",
        situation: "Mica mining as alternative",
        p1: "Mica, a mineral from mining, also provides pearlescent effects in cosmetics, while posing other risks…",
        li1: "Heavy metal exposure",
        li2: "Air pollution",
        li3: "Geological remnant",
        p2: "Above all, a humanistic problem is →",
        id: 5
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/background-6.jpg",
        situation: "Child labor in mica mining",
        p1: "Many developing countries allow children to work in the mining of mica, the issues of which include…",
        li1: "Unethical employment",
        li2: "Chronic hazard exposure",
        li3: "Physical exhaustion",
        p2: "So, how can we solve these problems?",
        id: 6
    }
];

export default function HorizontalScrollBackground(){
    return(
        <HorizontalScrollCarousel />
    )
}